import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const BOOKMARK_CHALLENGE_START = '2026-03-18T00:00:00Z';
export const BOOKMARK_CHALLENGE_END = '2026-04-29T23:59:59Z';
export const BOOKMARK_CHALLENGE_DETAILS_PATH = '/search/post?id=1077&articleType=post';

export const isBookmarkChallengeActive = (): boolean => {
  const now = dayjs().utc();
  return now.isAfter(dayjs.utc(BOOKMARK_CHALLENGE_START)) && now.isBefore(dayjs.utc(BOOKMARK_CHALLENGE_END));
};
